import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-order-approval',
  templateUrl: './order-approval.component.html',
  styleUrls: ['./order-approval.component.scss']
})
export class OrderApprovalComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }


  simulate() {
    this.router.navigate(['/dashboard', { outlets: { 'dashboard-content': 'order-payment-info' } }]);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/order-approval/order-approval.component.ts